
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"m19 19.5 10-10v11l-4.359 4.359L29 29v11l-10-9.5zM34 11.5h5v5h-5zM14 22.5H9v5h5zM39 33.5h-5v5h5z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Vector",attrs:{"stroke":"#234652","d":"M11 23h1m1 0h1m-5 2h1m3 0h1m-5 2h1m1 0h1m22 7h1m3 0h1m-3 2h1m1 0h1m-5 0h1m3 2h1m-5-22h1m3-2h1m-3-2h1m1 4h1m-5-2h1m1 0h1M6 19.5h11v11H6zm25-11h11v11H31zm0 22h11v11H31z"}}),_c('path',{staticClass:"i-Line 126",attrs:{"stroke":"#234652","stroke-dasharray":"1 1","d":"m20.046 23.466 7.889-7.889"}}),_c('path',{staticClass:"i-Line 127",attrs:{"stroke":"#234652","stroke-dasharray":"1 1","d":"m20.147 25.95 7.889 7.889"}})])
          )
        }
      }
    